/**
 * Stable identity of the Guided Interview experience that produced a build's
 * design context. This is intentionally separate from interview `depth`
 * (`quick`/`advanced`) and create `kickoffMode`: those fields control flow,
 * while this value makes the interview reproducible for resume and evals.
 */
export const GUIDED_INTERVIEW_VERSIONS = ['v1', 'v2', 'v3'];
/** Old clients and artifacts predate explicit versioning and therefore mean v1. */
export const LEGACY_GUIDED_INTERVIEW_VERSION = 'v1';
/** New creates explicitly choose v3; this is not a rollout flag. */
export const RECOMMENDED_GUIDED_INTERVIEW_VERSION = 'v3';
export function isGuidedInterviewVersion(value) {
    return value === 'v1' || value === 'v2' || value === 'v3';
}
export function resolveGuidedInterviewVersion(value) {
    return isGuidedInterviewVersion(value) ? value : LEGACY_GUIDED_INTERVIEW_VERSION;
}
//# sourceMappingURL=interview-version.js.map